export default `
    <h1>
      CONTRATO LEGAL DE DISTRIBUCIÓN B2B PARA INVESTHINKS
    </h1>
    
    <h3>PARTES CONTRATANTES:</h3>
    
    <p>1. <strong>De una parte, INVESTHINKS, S.L.,</strong> con CIF B06986152, domiciliada en la calle Teodoro Canet 28, Alcúdia (07400), Islas Baleares, representada por su administrador/a, [Nombre del representante]. En adelante, <strong>"INVESTHINKS"</strong>.</p>
    <p>2. <strong>De otra parte, el DISTRIBUIDOR,</strong> persona física o jurídica que completa el proceso de registro como distribuidor de INVESTHINKS en la plataforma, aceptando las condiciones de este contrato mediante la activación de una casilla durante el proceso de registro. En adelante, <strong>"EL DISTRIBUIDOR"</strong>.</p>
    
    <h3>CLÁUSULAS</h3>
    

    <p><strong>PRIMERA. OBJETO DEL CONTRATO</strong></p>
    <p>El presente contrato tiene por objeto establecer las condiciones generales de colaboración entre INVESTHINKS y EL DISTRIBUIDOR para la promoción y distribución de los servicios de trading automatizado de INVESTHINKS entre los clientes del DISTRIBUIDOR, actuando como intermediario independiente.</p>

    <p><strong>SEGUNDA. DEFINICIONES DE TÉRMINOS</strong></p>
    <ul>
        <li><p><strong>Cliente:</strong> Cualquier persona que haya sido presentada por EL DISTRIBUIDOR y que cumpla los requisitos para abrir una cuenta en Investhinks, con al menos una operación activa.</p></li>
        <li><p><strong>Cuenta Investhinks:</strong> Acceso a la plataforma de INVESTHINKS para gestionar las operaciones de trading automatizado y visualizar el rendimiento.</p></li>
        <li><p><strong>Distribuidor:</strong> Persona física o jurídica que actúa como intermediario independiente para presentar clientes a INVESTHINKS.</p></li>
        <li><p><strong>Comisiones del Distribuidor:</strong> Remuneración que EL DISTRIBUIDOR recibe en función de los clientes introducidos y de su rendimiento.</p></li>
        <li><p><strong>Programa de Distribución:</strong> Sistema de referencia que permite a EL DISTRIBUIDOR obtener comisiones por cada cliente que registra.</p></li>
    </ul>
    
    <p><strong>TERCERA. CONDICIONES DEL PROGRAMA DE DISTRIBUCIÓN</strong></p>
    <ol>
        <li><p>EL DISTRIBUIDOR obtendrá comisiones por cada cliente que introduzca y que mantenga una cuenta activa con un bot de inversión conectado.</p></li>
        <li><p>Las comisiones se calcularán según un porcentaje del rendimiento generado por cada cliente, según los tramos definidos en el Anexo I.</p></li>
        <li><p>Las comisiones se pagarán a la cartera electrónica del DISTRIBUIDOR, disponible en su panel de control.</p></li>
        <li><p>EL DISTRIBUIDOR será responsable de la promoción de los servicios de INVESTHINKS de manera ética, cumpliendo con las normativas aplicables y evitando prácticas engañosas.</p></li>
    </ol>

    <p><strong>CUARTA. DERECHOS Y OBLIGACIONES DE INVESTHINKS</strong></p>
    <ol>
        <li><p>INVESTHINKS proporcionará a EL DISTRIBUIDOR acceso a su panel de control, material de marketing, formación y soporte técnico.</p></li>
        <li><p>INVESTHINKS se compromete a procesar las comisiones mensualmente, siempre que EL DISTRIBUIDOR cumpla los requisitos.</p></li>
        <li><p>INVESTHINKS se reserva el derecho de modificar las condiciones del programa de distribución con previo aviso de 15 días.</p></li>
        <li><p>INVESTHINKS puede rescindir el contrato inmediatamente en caso de incumplimiento grave por parte del DISTRIBUIDOR.</p></li>
    </ol>

    <p><strong>QUINTA. DERECHOS Y OBLIGACIONES DEL DISTRIBUIDOR</strong></p>
    <ol>
        <li><p>EL DISTRIBUIDOR tiene derecho a recibir las comisiones generadas por los clientes que introduzca.</p></li>
        <li>
            <p>EL DISTRIBUIDOR se compromete a:</p>
            <ul>
                <li><p>Utilizar el material de marketing proporcionado por INVESTHINKS.</p></li>
                <li><p>No utilizar el logotipo de INVESTHINKS sin autorización previa.</p></li>
                <li><p>No registrar nombres de dominio que incluyan la marca "Investhinks".</p></li>
                <li><p>No enviar correos masivos no solicitados (spam) ni hacer publicidad engañosa.</p></li>
            </ul>
        </li>
        <li><p>EL DISTRIBUIDOR será responsable de cumplir con sus obligaciones fiscales derivadas de los ingresos por comisiones.</p></li>
    </ol>

    <p><strong>SEXTA. CONDICIONES DE ACTIVIDAD DEL DISTRIBUIDOR</strong></p>
    <ol>
        <li><p>EL DISTRIBUIDOR deberá tener una cuenta personal (como persona física o jurídica) en Investhinks con, como mínimo, un bot conectado y en activo.</p></li>
        <li><p>EL DISTRIBUIDOR deberá tener una actividad continua, incorporando como mínimo un cliente activo cada 60 días.</p></li>
        <li><p>En caso de inactividad durante 120 días consecutivos, INVESTHINKS se reserva el derecho de suspender las comisiones pendientes.</p></li>
        <li><p>Cualquier fraude detectado en la actividad del DISTRIBUIDOR implicará la rescisión inmediata del contrato.</p></li>
    </ol>

    <p><strong>SÉPTIMA. PROTECCIÓN DE DATOS Y CONFIDENCIALIDAD</strong></p>
    <ol>
        <li><p>EL DISTRIBUIDOR se compromete a mantener la confidencialidad de toda la información comercial, técnica y financiera proporcionada por INVESTHINKS.</p></li>
        <li><p>Los datos personales de los clientes introducidos serán gestionados exclusivamente por INVESTHINKS, de acuerdo con la legislación vigente de protección de datos.</p></li>
        <li><p>EL DISTRIBUIDOR no podrá conservar ni tratar los datos de los clientes sin autorización.</p></li>
    </ol>

    <p><strong>OCTAVA. MODIFICACIÓN Y RESCISIÓN</strong></p>
    <ol>
        <li><p>INVESTHINKS se reserva el derecho de modificar este contrato, notificando los cambios con una antelación mínima de 15 días.</p></li>
        <li><p>Cualquiera de las partes podrá rescindir el contrato con un preaviso de 15 días, excepto en caso de incumplimiento grave.</p></li>
        <li><p>En caso de rescisión, EL DISTRIBUIDOR recibirá las comisiones pendientes, siempre que cumpla las condiciones establecidas.</p></li>
    </ol>

    <p><strong>NOVENA. LEGISLACIÓN APLICABLE Y JURISDICCIÓN</strong></p>
    <ol>
        <li><p>El presente contrato se regirá por la legislación española.</p></li>
        <li><p>Para la resolución de cualquier conflicto derivado de este contrato, las partes se someten expresamente a los Juzgados y Tribunales de Palma.</p></li>
    </ol>

    <p><strong>DÉCIMA. ACEPTACIÓN ELECTRÓNICA</strong></p>
    <ol>
        <li><p>EL DISTRIBUIDOR acepta este contrato de manera electrónica activando la casilla de aceptación durante el proceso de registro.</p></li>
        <li><p>Esta aceptación electrónica tiene la misma validez legal que una firma manuscrita.</p></li>
    </ol>
    
    <h2>ANEXO I: CONDICIONES DE COMISIÓN</h2>
    
    <ul>
        <li><p>Tramo 1: 5% (IVA incluido) del rendimiento mensual de las cuentas de los clientes introducidos por EL DISTRIBUIDOR.</p></li>
    </ul>
`;
